export enum EventSourceType {
  CloudWatch = 'CloudWatch',
  Prometheus = 'Prometheus',
  Undefined = 'Undefined',
}
